<div class="space-y-4">
  <p class="text-xs text-gray-500 dark:text-gray-400">
    Define las franjas horarias en las que se puede agendar este tipo de reunión.
    Si no agregas ninguna franja, el tipo <span class="font-medium">no restringe</span> los horarios.
  </p>

  <!-- Alta de nueva franja -->
  <div class="p-3 rounded-lg border border-gray-200 dark:border-gray-700">
    <div class="grid grid-cols-1 md:grid-cols-[1fr_auto_auto_auto] gap-2 items-end">
      <div>
        <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">Día</label>
        <select [(ngModel)]="newDay"
          class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
          @for (d of days; track d.value) {
            <option [ngValue]="d.value">{{ d.label }}</option>
          }
        </select>
      </div>
      <div>
        <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">Desde</label>
        <input type="time" [(ngModel)]="newStart"
          class="px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
      </div>
      <div>
        <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">Hasta</label>
        <input type="time" [(ngModel)]="newEnd"
          class="px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
      </div>
      <button type="button" (click)="add()" [disabled]="saving"
        class="px-3 py-1.5 text-sm rounded-lg font-medium bg-brand-500 text-white hover:bg-brand-600 disabled:opacity-50">
        + Agregar
      </button>
    </div>
  </div>

  @if (loading) {
    <p class="text-sm text-gray-500 dark:text-gray-400">Cargando...</p>
  } @else if (items.length === 0) {
    <p class="text-sm text-gray-500 dark:text-gray-400">
      No hay franjas configuradas — este tipo no restringe horarios.
    </p>
  } @else {
    <ul class="divide-y divide-gray-200 dark:divide-gray-700 border border-gray-200 dark:border-gray-700 rounded-lg">
      @for (item of items; track item.id) {
        <li class="py-2 px-3 flex items-center justify-between gap-3 flex-wrap">
          @if (editingId === item.id) {
            <div class="flex items-center gap-2 flex-wrap">
              <span class="font-medium text-gray-900 dark:text-white text-sm w-24">{{ dayLabel(item.dayOfWeek) }}</span>
              <input type="time" [(ngModel)]="edit.start"
                class="px-2 py-1 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
              <span class="text-gray-400">—</span>
              <input type="time" [(ngModel)]="edit.end"
                class="px-2 py-1 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
            </div>
            <div class="flex items-center gap-2">
              <button type="button" (click)="saveEdit(item)" [disabled]="saving"
                class="text-xs px-2 py-1 rounded font-medium bg-brand-500 text-white hover:bg-brand-600 disabled:opacity-50">
                Guardar
              </button>
              <button type="button" (click)="cancelEdit()"
                class="text-xs px-2 py-1 rounded border border-gray-300 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-300">
                Cancelar
              </button>
            </div>
          } @else {
            <div class="flex items-center gap-3 flex-wrap">
              <span class="font-medium text-gray-900 dark:text-white text-sm w-24">{{ dayLabel(item.dayOfWeek) }}</span>
              <span class="text-sm text-gray-700 dark:text-gray-300">{{ timeString(item.startTime) }} — {{ timeString(item.endTime) }}</span>
            </div>
            <div class="flex items-center gap-2">
              <button type="button" (click)="startEdit(item)"
                class="text-xs px-2 py-1 rounded border border-gray-300 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-300">
                Editar
              </button>
              <button type="button" (click)="remove(item)"
                class="text-xs px-2 py-1 rounded border border-error-300 text-error-600 hover:bg-error-50">
                Eliminar
              </button>
            </div>
          }
        </li>
      }
    </ul>
  }
</div>
